import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from '../components/admin/AdminLayout.jsx'
import ThemeManager from '../components/admin/ThemeManager.jsx'
import DeckManager from '../components/admin/DeckManager.jsx'
import DeckDetail from '../components/admin/DeckDetail.jsx'
import QuestionEditor from '../components/admin/QuestionEditor.jsx'
import UserManager from '../components/admin/UserManager.jsx'
import AdminUserProfile from '../components/admin/AdminUserProfile.jsx'
import Dashboard from '../components/admin/Dashboard.jsx'
import FeedbackManager from '../components/admin/FeedbackManager.jsx'
import AdminMusicPage from '../components/admin/AdminMusicPage.jsx'

export default function AdminPage() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="themes" element={<ThemeManager />} />
        <Route path="musiques" element={<AdminMusicPage />} />
        <Route path="decks" element={<DeckManager />} />
        <Route path="decks/:deckId" element={<DeckDetail />} />
        <Route path="decks/:deckId/questions" element={<QuestionEditor />} />
        <Route path="users" element={<UserManager />} />
        <Route path="users/:userId/profile" element={<AdminUserProfile />} />
        <Route path="feedbacks" element={<FeedbackManager />} />
      </Routes>
    </AdminLayout>
  )
}
